(function () {
  var LS = { get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } }, set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} }, del: function (k) { try { localStorage.removeItem(k); } catch (e) {} } };
  var SS = { get: function (k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }, set: function (k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }, del: function (k) { try { sessionStorage.removeItem(k); } catch (e) {} } };

  function val(form, name) { var el = form.elements[name]; return el ? String(el.value || '').trim() : ''; }

  function validate(form) {
    var bad = [];
    form.querySelectorAll('[required]').forEach(function (el) {
      var ok = el.type === 'checkbox' ? el.checked : (el.value || '').trim() !== '' && (el.type !== 'email' || /.+@.+\..+/.test(el.value));
      var mark = el.type === 'checkbox' ? el.closest('.ae-check') : el;
      if (mark) mark.classList.toggle('is-bad', !ok);
      if (!ok) bad.push(el);
    });
    return bad;
  }

  function showState(sec, which) {
    var form = sec.querySelector('[data-ae-rsvp]');
    var done = sec.querySelector('[data-ae-done]');
    var pend = sec.querySelector('[data-ae-pending]');
    if (done) done.hidden = which !== 'done';
    if (pend) pend.hidden = which !== 'pending';
    if (form) form.hidden = which === 'done' || which === 'pending';
  }

  document.querySelectorAll('[data-ae-rsvp]').forEach(function (form) {
    var sec = form.closest('.ae-rsvp');
    var vid = form.getAttribute('data-variant');
    var key = 'ae_rsvp_' + vid;
    var err = form.querySelector('[data-ae-err]');

    if (LS.get(key)) {
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
        var inCart = (cart.items || []).some(function (i) { return String(i.variant_id) === String(vid); });
        showState(sec, inCart ? 'pending' : 'done');
      }).catch(function () {});
    }

    form.addEventListener('input', function (e) { var t = e.target; if (t.classList.contains('is-bad')) validate(form); var c = t.closest && t.closest('.ae-check.is-bad'); if (c && t.checked) c.classList.remove('is-bad'); });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var bad = validate(form);
      if (bad.length) {
        err.textContent = bad.some(function (b) { return b.type === 'checkbox'; }) && bad.length === bad.filter(function (b) { return b.type === 'checkbox'; }).length ? 'Please check every box to confirm.' : 'Please fill in the highlighted fields.';
        err.hidden = false;
        var first = bad[0]; (first.closest('.ae-check') || first).scrollIntoView({ block: 'center', behavior: 'smooth' }); if (first.focus) first.focus({ preventScroll: true });
        return;
      }
      err.hidden = true;
      var btn = form.querySelector('button[type=submit]');
      btn.disabled = true; btn.textContent = 'Saving your spot…';
      var props = {
        'Event': form.getAttribute('data-event'),
        'Name': val(form, 'First name') + ' ' + val(form, 'Last name'),
        'Email': val(form, 'Email'),
        'Phone': val(form, 'Phone'),
        'Instagram': val(form, 'Instagram'),
        'Vehicle': [val(form, 'Vehicle year'), val(form, 'Vehicle make'), val(form, 'Vehicle model')].join(' '),
        'Tire size': val(form, 'Tire size'),
        'Passengers': val(form, 'Passengers'),
        'Radio': val(form, 'Radio'),
        'Emergency contact': val(form, 'Emergency contact') + ' · ' + val(form, 'Emergency phone'),
        'Notes': val(form, 'Notes'),
        'Acknowledgements': 'All confirmed'
      };
      if (form.querySelector('[data-waiver]')) props['Waiver'] = 'Agreed';
      Object.keys(props).forEach(function (k) { if (!props[k]) delete props[k]; });
      var upd = {}; upd[vid] = 0;
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: upd }) })
        .then(function () {
          return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1, properties: props }] }) });
        })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () {
          LS.set(key, String(Date.now()));
          showState(sec, 'pending');
          window.location.href = '/checkout';
        })
        .catch(function (j) {
          btn.disabled = false; btn.textContent = 'Submit RSVP';
          var msg = (j && (j.description || j.message)) || '';
          err.textContent = /sold out|already sold|not enough|quantity/i.test(msg) ? 'Sorry, all spots were just claimed. Refresh the page to join the waitlist.' : 'Something went wrong. Please try again, or use Ask ADV below.';
          err.hidden = false;
        });
    });

    var again = document.createElement('button');
    again.type = 'button'; again.className = 'ae-btn ae-btn--ghost'; again.textContent = 'RSVP another rig';
    again.addEventListener('click', function () { LS.del(key); showState(sec, 'form'); });
    var done = sec.querySelector('[data-ae-done]'); if (done) done.appendChild(again);
  });

  document.querySelectorAll('[data-ae-contact]').forEach(function (wrap) {
    var k = wrap.getAttribute('data-ae-contact');
    var form = wrap.querySelector('form');
    if (form) form.addEventListener('submit', function () { SS.set('ae_posted', k); });
  });
  var posted = SS.get('ae_posted');
  if (posted && /contact_posted=true/.test(location.search)) {
    var msg = document.querySelector('[data-ae-posted="' + posted + '"]');
    var wrap = document.querySelector('[data-ae-contact="' + posted + '"]');
    if (msg) {
      msg.hidden = false; if (wrap) wrap.hidden = true;
      var d = msg.closest('details'); if (d) d.open = true;
      setTimeout(function () { msg.scrollIntoView({ block: 'center' }); }, 300);
    }
    SS.del('ae_posted');
  }
})();